import type IAnalyticsConfig from '../IAnalyticsConfig'
import { loadGoogleAnalytics, loadGoogleTagManager } from '@/composables/analytics-utils'
import Analytics from './Analytics'

export default class QuotaxAnalytics extends Analytics {
  loadAnalytics(config: IAnalyticsConfig): void {
    // Google Tag Manager
    loadGoogleTagManager(window.injectedEnv.FRONTEND_GTM)

    // Google Analytics
    loadGoogleAnalytics(config)
  }
}
